import React from "react";
import {observer} from "mobx-react-lite";
import adminStore from "../../storage/AdminStore";
import appStore from "../../storage/AppStore";
import Select from "../../ui/Select";
import {BsSearch} from "react-icons/bs";
import Btn from "../../ui/Btn";
import Input from '../../ui/Input'
import MultipleSelect from '../../ui/MultipleSelect'

const CompaniesSearch = () => {
  return (
      <form className="row row-cols-sm-auto g-3 align-items-center">
          <div className="col-12">
              <Input store={adminStore.companies_query} prop={'name'} label={'Аты'}/>
          </div>
          <div className="col-12" style={{minWidth: '250px'}}>
              <Select options={appStore.countries} store={adminStore.companies_query} prop={'country_id'}
                                label={'Өлкө'} for_search={true}/>
          </div>
          <div className="col-12" style={{minWidth: '250px'}}>
              <MultipleSelect options={appStore.sports} store={adminStore.companies_query} prop={'sports'}
                                     label={'Спорт'}/>
          </div>
          <div className="col-12">
              <Btn className={"btn btn-primary"} onClick={() => adminStore.searchCompanies()}><BsSearch/></Btn>
          </div>
      </form>
  );
};

export default observer(CompaniesSearch);